:root {
  --link-color: #0e5d81;
}

.footer {
  background-color: #f1f1f1;

  @media print {
    display: none;
  }
}

.footerContent {
  margin: 0 auto;
  max-width: 1216px;
  display: flex;
  padding: 24px 16px 40px;

  & > .footerLink {
    margin-left: 2rem;
    display: flex;
    align-items: center;

    & > span {
      font-size: 14px;
      color: var(--link-color);
      border-bottom: 1px dashed var(--link-color);

      &:hover {
        color: var(--link-color);
      }
    }
  }

  @media (max-width: 768px) {
    align-items: center;
    flex-direction: column;

    & > .logo {
      margin-bottom: 2rem;
    }

    & > a.footerLink {
      margin-left: 0;
    }
  }
}

.logo {
  flex-grow: 1;
}
